import React from 'react';
import { useQuery, useLazyQuery } from '@common/hooks';
import moment from 'moment';
import { ErrorHandler } from '@common/components';
import {
  CanShowPhiQuery,
  CanShowPhiQueryQueryArgs,
  CanShowPhiQueryQueryResponse,
  DateOfBirthQuery,
  DateOfBirthQueryArgs,
  DateOfBirthQueryResponse,
} from '@clinician-profile/graphql';

export const DateOfBirthLink = ({
  worksProfileId,
}: {
  worksProfileId: string;
}) => {
  const { data: worksProfileData } = useQuery<
    CanShowPhiQueryQueryResponse,
    CanShowPhiQueryQueryArgs
  >(CanShowPhiQuery, {
    variables: {
      id: worksProfileId,
    },
  });
  const [getWorksProfileDob, { error, data }] = useLazyQuery<
    DateOfBirthQueryResponse,
    DateOfBirthQueryArgs
  >(DateOfBirthQuery, {
    variables: {
      id: worksProfileId,
    },
  });

  const dobShowDisabled = function () {
    if (!worksProfileData || !worksProfileData.worksProfile.canShowPhi) {
      return true;
    }

    return !worksProfileData.worksProfile.canShowPhi.value;
  };

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="DateOfBirthLink"
        messageType="contextual"
      />
    );
  }

  if (dobShowDisabled()) {
    return null;
  }

  if (data?.worksProfileDateOfBirth) {
    return (
      <>
        {moment(data.worksProfileDateOfBirth.dateOfBirth).format('MM/DD/YYYY')}
      </>
    );
  } else {
    return (
      <a
        className="CandidateLink sentry-mask"
        onClick={() => getWorksProfileDob()}
      >
        Show Birthdate
      </a>
    );
  }
};
